import { environmentHttpClient } from "client/Api/httpClient";
import {
	KnowledgeItemPagingInformationModel,
	KnowledgeItemPreviewItemModel
} from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";
import { HubItemTileResourceId } from "../../workspace";

export type KnowledgeItemInterests = {
	items: boolean | null;
	lastPinnedItem: boolean | null;
};

export type LiveInformationKnowledgeItemRequestModel = {
	resource: HubItemTileResourceId;
	interests: KnowledgeItemInterests;
};

export type LiveInformationKnowledgeItemResponseModelData = {
	items: LazyLoadPageResult<KnowledgeItemPreviewItemModel> | null;
	lastPinnedItem: KnowledgeItemPreviewItemModel | null;
};

export type LiveInformationKnowledgeItemResponseModel = {
	resource: HubItemTileResourceId;
	data: LiveInformationKnowledgeItemResponseModelData;
};

export type LoadMoreKnowledgeItemsRequest = {
	categoryIds: readonly number[] | null;
	lastRetrievedItem: KnowledgeItemPagingInformationModel;
};

export function list(
	requestModels: readonly LiveInformationKnowledgeItemRequestModel[]
): Promise<readonly LiveInformationKnowledgeItemResponseModel[]> {
	return environmentHttpClient.post<readonly LiveInformationKnowledgeItemResponseModel[]>(
		"Workspace/LiveInformation/KnowledgeItems",
		requestModels
	);
}

export function listMore(
	request: LoadMoreKnowledgeItemsRequest,
	signal?: AbortSignal
): Promise<LazyLoadPageResult<KnowledgeItemPreviewItemModel>> {
	return environmentHttpClient.post<LazyLoadPageResult<KnowledgeItemPreviewItemModel>>(
		"Workspace/LiveInformation/KnowledgeItems/More",
		request,
		{ signal }
	);
}
